import {NgModule} from "@angular/core"
import {AngularFirestoreModule} from "@angular/fire/compat/firestore";
import {AngularFireAuthModule} from "@angular/fire/compat/auth";
import {AngularFireModule} from "@angular/fire/compat";
import {firebaseConfig} from "../environments/environment";
import {provideRouter, RouteReuseStrategy} from "@angular/router";
import {IonicRouteStrategy, provideIonicAngular} from "@ionic/angular/standalone";
import {routes} from "./app.routes";
import {provideHttpClient} from "@angular/common/http";
import {AppComponent} from "./app.component";
import {BrowserModule} from "@angular/platform-browser";
import {IonicModule} from "@ionic/angular";

@NgModule({
	declarations: [AppComponent],
	imports: [
		IonicModule,
		BrowserModule,
		AngularFireModule.initializeApp(firebaseConfig, 'Ramus.je - Tichá aukce'),
		AngularFireAuthModule,
		AngularFirestoreModule,
	],
	providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({mode: 'md'}),
    provideRouter(routes),
    provideHttpClient(),
  ],
	bootstrap: [AppComponent]
})
export class AppModule{}
